import React, { FC } from 'react';

import { Tag } from 'containers/pages/courses-list/components/course-item/styled';
import DOMPurify from 'dompurify';

import { useTranslation } from 'react-i18next';
import { KidsCourse } from 'types';
import {
    Announcement,
    Content,
    Description,
    ImageBlock,
    TagBlock,
    Title,
} from '../../../courses-list/components/profession-item/styled';
import {
    ButtonBlock,
    ButtonLink,
} from '../../../courses-list/components/styled';

interface IProps {
    course: KidsCourse;
}

export const ProfessionItem: FC<IProps> = ({ course }) => {
    const { t } = useTranslation(['common/shared', 'pages/kids-courses']);

    return (
        <Content>
            <Description>
                <TagBlock>
                    <Tag variant={'gradient'}>
                        {t('pages/kids-courses:interest-1')}
                    </Tag>
                </TagBlock>

                <Title target={'_blank'} to={course.link}>
                    {course.title}
                </Title>
                <Announcement
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(course.description),
                    }}
                />
                <ButtonBlock>
                    <ButtonLink target={'_blank'} to={course.link}>
                        {t('common/shared:know-more')}
                    </ButtonLink>
                </ButtonBlock>
            </Description>
            <ImageBlock image={course.image?.fileLink ?? ''} />
        </Content>
    );
};
